import { DynamicObjectInterface } from '@commerce-profile-webcomponents/sdk';
import { MLPVersion } from '@nextgen-web-framework/all';

export enum DropDownSelectType {
  DRAWER = 'DRAWER',
  DROPDOWN = 'DROPDOWN',
}

export interface DropDownOptionData {
  [key: string]: DynamicObjectInterface;
}

export interface DropDownwithMasterData {
  fieldName: string;
  value?: string;
  onSelect?: (key: string, value?: string) => void;
  disabled?: boolean;
  translationPrefix?: string;
  showSearch?: boolean;
  dropDownSelectType?: DropDownSelectType;
  mlpVersionProp?: MLPVersion;
}
